// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (el: any, binding: any) => {
  if (process.env.NODE_ENV === "test") {
    Object.keys(binding.value).forEach((value) => {
      el.setAttribute(`data-test-${value}`, binding.value[value]);
    });
  }
};
